<template>
  <div>
    <p class="pding20 fb" style="font-size:16px">{{msgInfo.msgTitle}}</p>
    <el-form ref="form" :model="msgInfo" label-width="120px" style="margin:20px">
      <el-form-item>
        <div slot="label">
        <i class="el-icon-user" style="font-size:20px" ></i>
        发&ensp;送&ensp;人：
        </div>
        <el-input v-model="sender" readonly></el-input>
      </el-form-item>
      <el-form-item>
        <div slot="label">
        <i class="el-icon-time" style="font-size:20px" ></i>
        发送时间：
        </div>
        <el-date-picker
        readonly
          type="datetime"
          placeholder="选择日期"
          v-model="msgInfo.createtime"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <div slot="label">
        <i class="el-icon-link" style="font-size:20px" ></i>
        关联事项：
        </div>
        <el-input v-model="msgInfo.f4" readonly></el-input>
      </el-form-item>
      <el-form-item>
        <div slot="label">
        <i class="el-icon-chat-line-square" style="font-size:20px" ></i>
        消息内容：
        </div>
        <el-input type="textarea" v-model="msgInfo.msg" readonly></el-input>
      </el-form-item>

    </el-form>
<div style="display:flex;justify-content: center">
  <el-button type="success" @click="topage()"  class="btn1">查看事项详情</el-button>
<el-button @click="goBack" class="btn2">返回</el-button>
</div>

  </div>
</template>
<script>
import { queryServiceInfo,getByServiceRunId } from '@/api/serviceInfo'

export default {
  data() {
    return {
      msgInfo: {
        sendUser: "张三",
        sendDate: "2021-09-10 9:12:21",
        relatedMatters: "学籍异动申请",
        msg: '',
      },
      sender:'系统'
    };
  },
  mounted() {
    this.msgId = this.$route.query.id
    this.msgInfo=JSON.parse(sessionStorage.getItem('msgInfo'))
    this.getServiceInfo()
  },
  methods: {
    topage() {
      let id=this.msgInfo.f1.split('-')[0]
      if(this.msgInfo.msgSource=="校长直通车"){
        this.$router.push("/feedbackDetail?id="+id);
      }else{
        getByServiceRunId(id).then(res => {
          if(res.msgCode == '0'){
            this.$router.push(
              "/userCenter/matterInfo?detailid=" +
                res.data.serviceRunid +
                "&id=" +
                res.data.f4 +
                "&runid=" +
                res.data.id
            );
          }
        })
      }
    },
    goBack() {
      sessionStorage.removeItem('msgInfo')
      if(this.$route.query.page==1){
        this.$router.push("/userCenter/userMsg");
      }else{
        this.$router.push("/userCenter");
      }
      
    },
     // 查询 服务详情信息
     async getServiceInfo() {
      const data = await queryServiceInfo(this.msgInfo.f3)
      if (data.msgCode == 0) {
        sessionStorage.setItem('xzztcToken', data.data.serviceSecret);
      }
    },
  },
};
</script>
<style> 
.btn1.el-button{
  background-color:#008A2C;
}
.btn1.el-button:hover {
    color: white;
    border-color: #e0fae8;
    background-color: #008a2cc9;
}
.btn2.el-button:hover {
    color: #008A2C;
    border-color: #e0fae8;
    background-color: #c6f6d5b7;
}
</style>